// extracted by mini-css-extract-plugin
module.exports = {"icons":"contractualaccountselect_icons__3nzaW","textContent":"contractualaccountselect_textContent__18gzY"};